<div class="atlas-form mct-flex mct-col mct-gap-27"  >
  <div>
    <label>{{ 'profiles.edit.membership-information.membership-level' | translate | titlecase }}</label>
    <select [disabled]="!value.Member" class="form-control" [(ngModel)]="value.MembershipLevelId">
      <option value="0">{{ 'common.none' | translate | titlecase }}</option>
      <option *ngFor="let memLevel of membershipLevels" [value]="memLevel.MembershipLevelId">{{ memLevel.Name }}</option>
    </select>
  </div>
  <div>
    <label>{{ 'profiles.edit.membership-information.member-since' | translate | titlecase }}</label>
    <div [hidden]="!(value.MemberSince || MemberSince.dirty)">
      <wl-date-selector
        [disabled]="!value.Member"
        id="MemberSince"
        name="MemberSince"
        [(ngModel)]="value.MemberSince"
        #MemberSince="ngModel"
      ></wl-date-selector>
    </div>
  </div>
  <div class="mct-flex mct-col" >
    <label>{{ 'profiles.edit.membership-information.member-source' | translate | titlecase }}</label>
    <p-select
      [disabled]="!value.Member"
      appendTo="body"
      [(ngModel)]="value.MemberSource"
      [options]="memberSourceItems"
    ></p-select>
  </div>
  <div class="mct-flex mct-col" >
    <label>{{ 'profiles.edit.membership-information.member-notes' | translate | titlecase }}</label>
    <textarea class="form-control" [(ngModel)]="value.MemberNotes" name="notes" style="height: 350px"></textarea>
  </div>
</div>
